import MoreVertIcon from "@material-ui/icons/MoreVert";
import React, { useRef } from "react";
import useOutsideClick from "../../hooks/useOutsideClick";
import SmallBalance from "./SmallBalance";
import classes from "./SmallHeader.module.scss";
import SmallHelp from "./SmallHelp";
import SmallMessages from "./SmallMessages";
import SmallProfile from "./SmallProfile";
import { useTranslation } from "react-i18next";
import SmallDownloadApp from "./SmallDownloadApp";

export default function SmallHeader() {
  const { i18n } = useTranslation();
  const wrapperProfileRef = useRef(null);
  const [toggle, setToggle] = useOutsideClick(wrapperProfileRef);

  function handleClickMore() {
    setToggle(!toggle);
  }

  return (
    <>
      <span
        className={i18n.language === "en" ? classes.iconLtr : classes.icon}
        onClick={handleClickMore}
      >
        <MoreVertIcon id="moreVertIcon" fontSize="large" />
      </span>
      {toggle && (
        <div
          ref={wrapperProfileRef}
          className={
            i18n.language === "en"
              ? classes.mobileContainerLtr
              : classes.mobileContainer
          }
        >
          <div>
            <SmallProfile classes={classes} />
            <SmallBalance classes={classes} />
            <span className={classes.miniItemContainer}>
              <SmallMessages classes={classes} />
              <SmallDownloadApp classes={classes} />
              <SmallHelp classes={classes} />
            </span>
          </div>
        </div>
      )}
    </>
  );
}
